module.exports = __webpack_public_path__ + "asset/image-pro-discount-25-47488ee4c806e917.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/component/plans/component/plan/image/pro-discount-25.png
// module id = LyR9
// module chunks = 3